import axios from 'axios';

const reqUrl = process.env.NEXT_PUBLIC_RELEVANCE_PTAL_API_URL;

async function createPtal({
  objective,
  region,
  spo,
}: {
  objective: string;
  region: string;
  spo: string;
}) {
  const { data } = await axios.post(`${reqUrl}/trigger_limited_async`, {
    params: {
      po: objective,
      region: region,
      spo1: spo,
    },
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    studio_id: 'c31c1c28-1d41-441c-8678-0c2bdac8864c',
  });
  return data;
}

async function getPtal({ jobId }: { jobId: string }) {
  const params = {
    ending_update_only: false,
    project: '8f8205497a61-4568-b3f2-c46fb2b0bdef',
    sort: '[{"message_id":"desc"}]',
  };
  const { data } = await axios.get(`${reqUrl}/async_poll/${jobId}`, { params });
  return data;
}

export const ptals = {
  createPtal,
  getPtal,
};
